import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useGetPostTags } from "../../../hooks/blog/tags/useGetPostTags";
import { useDeletePostTag } from "../../../hooks/blog/tags/useDeletePostTag";
import useTableActions from "../../../hooks/common/useTableActions";

import TableLayout from "../../global/Table/TableLayout";
import { PostTagsTableColumns } from "./Table/PostTagsTableColumns";
import PostTagsTableRow from "./Table/PostTagsTableRow";

const PostTagsTable = () => {
    const { i18n } = useTranslation();
    const navigate = useNavigate();
    const lng = i18n.language || "en";
    const isArabic = lng.startsWith("ar");

    const { deleteTagMutate, isDeleting } = useDeletePostTag();

    const {
        page,
        perPage,
        search,
        order,
        selectedIds,
        menuAnchorEl,
        setSearch,
        handleRequestSort,
        handleRowCheckboxClick,
        handleSelectAllClick,
        handleMenuOpen,
        handleMenuClose,
        handleEdit,
        handleMenuDelete,
        handleBulkDelete,
        handlePageChange,
        handlePerPageChange,
    } = useTableActions({
        basePath: "/blog/tags",
        deleteSingle: deleteTagMutate,
    });

    const params = useMemo(() => {
        return {
            page,
            per_page: perPage,
            search: search || undefined,
            sort_by: "created_at",
            sort_order: order,
        };
    }, [page, perPage, search, order]);

    const { tags, meta, isLoading, error } = useGetPostTags(params);

    const renderRow = (rowProps) => (
        <PostTagsTableRow
            {...rowProps}
            item={rowProps.item}
            isSelected={selectedIds.includes(rowProps.item.id)}
            onRowCheckboxClick={handleRowCheckboxClick}
            onMenuOpen={handleMenuOpen}
        />
    );

    const title = isArabic ? "وسوم المدونة" : "Blog Tags";
    const subtitle = isArabic ? "إدارة وسوم مقالات المدونة" : "Manage blog post tags";

    return (
        <TableLayout
            title={title}
            subtitle={subtitle}
            search={search}
            onSearchChange={setSearch}
            addButtonLabel={isArabic ? "إضافة وسم" : "Add Tag"}
            onAddClick={() => navigate("/blog/tags/create")}
            isLoading={isLoading}
            error={error}
            items={tags}
            meta={meta}
            page={page}
            perPage={perPage}
            onPageChange={handlePageChange}
            onPerPageChange={handlePerPageChange}
            order={order}
            onRequestSort={handleRequestSort}
            selectedIds={selectedIds}
            onSelectAllClick={(e) => handleSelectAllClick(e, tags)}
            onRowCheckboxClick={handleRowCheckboxClick}
            onBulkDelete={handleBulkDelete}
            columns={PostTagsTableColumns}
            renderRow={renderRow}
            menuAnchorEl={menuAnchorEl}
            openMenu={Boolean(menuAnchorEl)}
            onMenuOpen={handleMenuOpen}
            onMenuClose={handleMenuClose}
            onMenuEdit={handleEdit}
            onMenuDelete={handleMenuDelete}
            isDeletingSingle={isDeleting}
            emptyLabelAr="لا توجد وسوم حالياً"
            emptyLabelEn="No tags found"
        />
    );
};

export default PostTagsTable;
